import axios from "axios";
import config from "../config";

// Header có Bearer token (nếu có)
const authHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    "";
  return { Authorization: `Bearer ${token || ""}` };
};

// GET /api/vouchers
export const getVouchers = async (params = {}) => {
  try {
    const res = await axios.get(`${config.apiBaseUrl}/vouchers`, {
      headers: authHeaders(),
      params,
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách voucher:", error);
    throw error;
  }
};

// GET /api/vouchers/{id}
export const getVoucherById = async (id) => {
  try {
    const res = await axios.get(`${config.apiBaseUrl}/vouchers/${id}`, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy voucher theo id:", error);
    throw error;
  }
};

// POST /api/vouchers
export const createVoucher = async (payload) => {
  try {
    const res = await axios.post(`${config.apiBaseUrl}/vouchers`, payload, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo voucher:", error);
    throw error;
  }
};

// PUT /api/vouchers/{id}
export const updateVoucher = async (id, payload) => {
  try {
    const res = await axios.put(`${config.apiBaseUrl}/vouchers/${id}`, payload, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi cập nhật voucher:", error);
    throw error;
  }
};

// DELETE /api/vouchers/{id}
export const deleteVoucher = async (id) => {
  try {
    const res = await axios.delete(`${config.apiBaseUrl}/vouchers/${id}`, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi xoá voucher:", error);
    throw error;
  }
};

// POST /api/vouchers/assign
// payload: { userId, voucherId, remainingUses, status, validFrom, validTo, source, note }
export const assignVoucher = async (payload) => {
  try {
    const res = await axios.post(
      `${config.apiBaseUrl}/vouchers/assign`,
      payload,
      { headers: authHeaders() }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi assign voucher:", error);
    throw error;
  }
};

// POST /api/vouchers/validate (cần login + [Authorize])
// payload: { code, orderTotal, productCount }
export const validateVoucher = async (payload) => {
  try {
    const res = await axios.post(
      `${config.apiBaseUrl}/vouchers/validate`,
      payload,
      { headers: authHeaders() }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi validate voucher:", error);
    throw error;
  }
};

// GET /api/vouchers/user/{userId}
export const getUserVouchers = async (userId) => {
  const res = await axios.get(`${config.apiBaseUrl}/vouchers/user/${userId}`, {
    headers: authHeaders(),
  });
  return res.data;
};

// PUT /api/vouchers/user-voucher/{userVoucherId}
export const updateUserVoucher = async (userVoucherId, payload) => {
  const res = await axios.put(
    `${config.apiBaseUrl}/vouchers/user-voucher/${userVoucherId}`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
};

// PUT /api/vouchers/user-voucher/{userVoucherId}/revoke
export const revokeUserVoucher = async (userVoucherId) => {
  const res = await axios.put(
    `${config.apiBaseUrl}/vouchers/user-voucher/${userVoucherId}/revoke`,
    {},
    { headers: authHeaders() }
  );
  return res.data;
};

// GET /api/vouchers/{voucherId}/users
export const getUsersByVoucher = async (voucherId) => {
  const res = await axios.get(
    `${config.apiBaseUrl}/vouchers/${voucherId}/users`,
    { headers: authHeaders() }
  );
  return res.data;
};

// PUT /api/vouchers/user-voucher/bulk-revoke
export const bulkRevokeUserVouchers = async (userVoucherIds = []) => {
  const res = await axios.put(
    `${config.apiBaseUrl}/vouchers/user-voucher/bulk-revoke`,
    userVoucherIds,
    { headers: authHeaders() }
  );
  return res.data;
};

